module.exports = __webpack_public_path__ + "media/src/images/abouts/brands/ubereats-0f438576316f42dc5f60dd8f4bd5fa56.jpg";